import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

export const sliderAroundTheCity = () => {
    $('.section-area .row-nav').slick({
        asNavFor: $('.section-area .row-for'),
        arrows: !1,
        slidesToShow: 16,
        focusOnSelect: !0,
        responsive: [{
            breakpoint: 992,
            settings: {
                centerPadding: '60px',
                slidesToShow: 5,
                centerMode: !0
            }
        }, {
            breakpoint: 768,
            settings: {
                centerPadding: '48px',
                slidesToShow: 3,
                centerMode: !0
            }
        }, {
            breakpoint: 576,
            settings: {
                centerPadding: '25%',
                slidesToShow: 1,
                centerMode: !0
            }
        }]
    })

    $('.section-area .row-for').slick({
        asNavFor: '.section-area .row-nav',
        arrows: !1,
        fade: !0,
        adaptiveHeight: !0
    })
}

export const sliderMostPopular = () => {
    $('.section-popular-stories .row-nav').slick({
        asNavFor: '.section-popular-stories .row-for',
        arrows: !1,
        slidesToShow: 3,
        focusOnSelect: !0,
    })

    $('.section-popular-stories .row-for').slick({
        asNavFor: '.section-popular-stories .row-nav',
        arrows: !1,
        adaptiveHeight: !0,
        fade: !0
    })
}